import { Controller } from "@hotwired/stimulus";

let mapboxgl;

export default class extends Controller {
  connect() {
    this.center = [9.111533716137924, 61.13930876367766];
    this.zoom = 6;
    this.pitch = 70;
    this.bearing = 10;
    import("mapbox-gl").then((module) => {
      mapboxgl = module.default;
      this.initMap();
    });
  }

  initMap() {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoic3RlaW5veSIsImEiOiI1MTM3NTEyYWE2NTFlNDhkN2RlMjA4YmM2N2Q0Y2RhZiJ9.WRxGhtW0fkfRVyCeGc8oDw";

    this.map = new mapboxgl.Map({
      container: "locations-map",
      style: "mapbox://styles/steinoy/ckyk8mxgc14hh15qlinjc6t4r",
      // center: this.center,
      // zoom: this.zoom,
      pitch: this.pitch,
      bearing: this.bearing,
      cooperativeGestures: true,
      locale: {
        "ScrollZoomBlocker.CtrlMessage":
          "Bruk ctrl + scroll for å zoome i kartet",
        "ScrollZoomBlocker.CmdMessage": "Bruk ⌘ + scroll for å zoome i kartet",
        "TouchPanBlocker.Message": "Bruk to fingre for å utforske kartet",
      },
    });

    this.map.on("load", () => {
      this.map.addSource("members", {
        type: "geojson",
        data: window._members,
        cluster: true,
        // clusterMaxZoom: 24, // Max zoom to cluster points on
        clusterRadius: 100,
      });

      this.map.addLayer({
        id: "clusters",
        type: "circle",
        source: "members",
        filter: ["has", "point_count"],
        paint: {
          "circle-color": [
            "step",
            ["get", "point_count"],
            "#4ab9ee",
            100,
            "#4ab9ee",
            750,
            "#4ab9ee",
          ],
          "circle-radius": [
            "step",
            ["get", "point_count"],
            20,
            100,
            30,
            750,
            40,
          ],
        },
      });

      this.map.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "members",
        filter: ["has", "point_count"],
        layout: {
          "text-field": "{point_count_abbreviated}",
          "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
          "text-size": 12,
        },
      });

      this.map.on("click", "clusters", (e) => {
        const features = this.map.queryRenderedFeatures(e.point, {
          layers: ["clusters"],
        });
        const clusterId = features[0].properties.cluster_id;
        this.map
          .getSource("members")
          .getClusterExpansionZoom(clusterId, (err, zoom) => {
            if (err) return;

            this.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom,
            });
          });
      });

      this.map.loadImage("/wp-content/themes/ne/marker.png", (error, image) => {
        if (error) throw error;
        this.map.addImage("custom-marker", image);

        this.map.addLayer({
          id: "points",
          type: "symbol",
          source: "members",
          filter: ["!", ["has", "point_count"]],
          layout: {
            "icon-image": "custom-marker",
            "icon-size": 0.5,
            "icon-anchor": "bottom",
          },
        });

        this.map.on("click", "points", (e) => {
          this.onMarkerClick(e.features[0].properties);

          this.map.flyTo({
            center: e.features[0].geometry.coordinates,
            zoom: 15,
          });
        });
      });

      this.map.addControl(
        new mapboxgl.NavigationControl({
          showZoom: true,
        })
      );

      if (this.onMapLoaded) {
        this.onMapLoaded();
      }

      let bounds = new mapboxgl.LngLatBounds();

      window._members.features.forEach(function (feature) {
        bounds.extend(feature.geometry.coordinates);
      });

      this.map.fitBounds(bounds, {
        maxZoom: window._members.length < 3 ? 13 : 7,
        // zoom: 15,
        animate: false,
      });
    });
  }

  onMarkerClick(member) {
    // let existsingActive = document.querySelector(".res--active");
    // if (existsingActive) {
    //   existsingActive.classList.remove("res--active");
    // }
    // let target = document.querySelector("#member-" + member.id);
    // target.classList.add("res--active");
    // if (window.innerWidth >= 992) {
    //   window.scrollTo({
    //     top: window.scrollY + target.getBoundingClientRect().top - 200,
    //     behavior: "smooth",
    //   });
    // } else {
    //   target.remove();
    //   let resWrap = this.element.querySelector(".locations__results__wrap");
    //   resWrap.prepend(target);
    //   window.scrollTo({
    //     top: window.scrollY + this.mapTarget.getBoundingClientRect().top,
    //     behavior: "smooth",
    //   });
    // }
  }

  disconnect() {
    this.map.remove();
  }
}
